module.exports = __webpack_public_path__ + "img/neteller.4f1be7a6.png";